exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer[data-v-2e481683]{text-align:center}.btn-secondary[data-v-2e481683]{border:1px solid}", ""]);

// exports
